import * as THREE from "three";
import Stats from "three/examples/jsm/libs/stats.module";
// 导入控制器
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'
import { RoomEnvironment } from "three/examples/jsm/environments/RoomEnvironment.js"
import { EXRLoader } from "three/examples/jsm/loaders/exrloader";
// core version + navigation, pagination modules:
import { utils } from "./utils/utils"
import { AudioPlayer } from './audioPlayer'
import { S51Config } from './utils/config'
import { CHAT_EVNET, CHAT_MSG_TYPE } from "./define";
import crypto from 'crypto-js'
import ActionMgr from "./action/actionMgr";

const EYE_BLINK_LEFT = 'eyeBlinkLeft'
const EYE_BLINK_RIGHT = 'eyeBlinkRight'
const EYE_BLINK_STEP = 0.05//眨眼步长
let g_removeDefaultFlag = false
let isLoading = false
let mainScene
let renderer
let mainCamera
let g_defaultClothesNames = []
let g_characterBones = new Map()
let g_clothesModels = []
let m_defaultClothMesh = []
const eyeBlindWaitCount = 60 * 3 //60fps*3秒
const WIDTH = 1080
const HEIGHT = 1920
const cameraPosition = [0, 1.4, 3]
const cameraCutImgPosition = [0, 1.4, 2.4]
//创建时钟
var clock = new THREE.Clock();
// 设置渲染频率为30FBS，也就是每秒调用渲染器render方法大约30次
var FPS = 60;
var renderT = 1 / FPS; //单位秒  间隔多长时间渲染渲染一次
// 声明一个变量表示render()函数被多次调用累积时间
// 如果执行一次renderer.render，timeS重新置0
var timeS = 0;
var myConsole=function(...args){
    return
    console.log(...args)
}
class WebGlLoader {
    constructor(documentContainer, backColor, secretConfig, isDev) {

        this.config = S51Config[isDev ? "dev" : "pro"]
        this.isDev = isDev ? isDev : false
        this.g_removeDefaultFlag = false
        this.loader = new GLTFLoader();
        this.g_model = undefined
        this.audioPlayer = new AudioPlayer()
        this.appID = secretConfig.appID
        this.token = secretConfig.token
        this.animationID = undefined
        this.clothSet = new Map()
        this.actionMgr = undefined
        this.mainModelMap = new Map()
        //眨眼参数
        this.lidMove = 0.08;
        this.lidSpeed = 0.08;
        this.lidWait = 1;

        this.cutImgCallBack = null;
        this.cutState = 0
        //初始化 threejs
        // myConsole('container ', documentContainer)

        this.container = documentContainer;
        // 加载左上角进度
        if (isDev) {
            this.stats = new Stats();
            this.stats.showPanel(2)
            this.container.appendChild(this.stats.dom);
            this.stats.dom.style.display = 'none'//默认隐藏
        }

        renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true//背景透明
        });
        myConsole('windows size', window.innerWidth, window.innerHeight)

        renderer.setPixelRatio(window.devicePixelRatio);
        // renderer.setSize(window.innerWidth, window.innerHeight);
        this.widht = window.innerWidth
        this.height = HEIGHT / WIDTH * window.innerWidth

        renderer.setSize(this.widht, this.height);
        renderer.outputEncoding = THREE.sRGBEncoding;//材质
        renderer.shadowMap.enabled = true;
        renderer.getContext().canvas.addEventListener('webglcontextlost', (event) => {
            myConsole('webglcontext lost')

        }, false)

        this.container.appendChild(renderer.domElement);
        this.pmremGenerator = new THREE.PMREMGenerator(renderer);
        mainScene = new THREE.Scene();
        // mainScene.background = new THREE.Color(backColor);
        // mainScene.environment = this.pmremGenerator.fromScene(new RoomEnvironment(), 0.04).texture;


        this.dirLight = new THREE.DirectionalLight(0xffffff, 0.4);
        this.dirLight.position.set(5, 10, 10);
        mainScene.add(this.dirLight);
       
        const light = new THREE.AmbientLight(0xffffff); // 创建一个环境光
        mainScene.add(light);
    

        mainCamera = new THREE.PerspectiveCamera(45, this.widht / this.height, 1, 1000);
        // camera.position.set( 15, 12, 18 );
        mainCamera.position.set(cameraPosition[0], cameraPosition[1], cameraPosition[2]);
        
        // 添加坐标轴辅助器
        // this.axesHelper = new THREE.AxesHelper(5);
        // mainScene.add(this.axesHelper);
        window.onresize = function () {
            this.width = window.innerWidth; //canvas画布高度
            this.height = HEIGHT / WIDTH * window.innerWidth; //canvas画布宽度
            renderer.setSize(this.width, this.height);
            mainCamera.aspect = this.width / this.height;
            mainCamera.updateProjectionMatrix();
        };
        this.controls = new OrbitControls(mainCamera, renderer.domElement);
        this.controls.target.set(0, 0.8, 0);
        this.controls.update();
        this.controls.enableDamping = true;
        // 限制 放大缩小
        this.controls.maxDistance = 8;
        this.controls.minDistance = 2.5;
        // 平移
        this.controls.listenToKeyEvents(window); // optional
        this.controls.enablePan = true; //开启右键拖拽
        this.controls.enableKeys = true
        this.controls.touches = {
            ONE: THREE.TOUCH.ROTATE,
            TWO: THREE.TOUCH.DOLLY_ROTATE
        }

        this.controls.minPolarAngle = 0; //上下翻转最小角度
        this.controls.maxPolarAngle = 2.2; //上下翻转最大角度


        if(secretConfig.helper){
            const dirHelper = new THREE.DirectionalLightHelper( this.dirLight, 1 );
            mainScene.add( dirHelper );
          
            const axesHelper = new THREE.AxesHelper( 5 );
            mainScene.add( axesHelper );

            //正交投影照相机
            // const camera2 = new THREE.OrthographicCamera(-1, 1, 1, -1, 5, 10);
     
            // camera2.position.set(cameraPosition[0],cameraPosition[1],cameraPosition[2],);
            // camera2.lookAt(new THREE.Vector3(0, 0, 0));
     
            // //照相机帮助线
            // const cameraHelper = new THREE.CameraHelper(camera2);
            // mainScene.add(cameraHelper);
        }
        


        //canvas居中
        renderer.domElement.style.position = 'absolute';
        renderer.domElement.style.top = '0';
        renderer.domElement.style.left = '0';
        renderer.domElement.style.top = '0';
        renderer.domElement.style.bottom = '0';
        renderer.domElement.style.margin = 'auto'
        this.animate()




    }
    /**
     * 重置一些参数
     */
    reset() {
        this.morphControl = undefined
        this.morphDict = undefined
        this.eyeBlinkChange = EYE_BLINK_STEP //默认先一步步闭眼睛
    }
    enableControl(enable) {
        this.controls.enabled = enable
    }
    resetAppID(appId) {
        this.appID = appId
    }
    updateClothesBone2CharacterBone() {

        g_clothesModels.forEach(obj => {
            let obj_ = obj.scene
            if (!obj_) return

            obj_ = obj_.getObjectByName("Armature")
            if (!obj_) return

            obj_ = obj_.getObjectByName("RootNode")
            if (!obj_) return

            obj_ = obj_.getObjectByName("Hips")
            //获取衣服的骨骼
            var objRootBone = obj_
            if (!objRootBone) { //没有找到根骨骼，怀疑是骨骼父节点名字错误，尝试遍历查找跟骨骼
                obj.scene.traverse(obj => {
                    if (obj.isBone && obj.name == "Hips") {
                        objRootBone = obj
                    }
                })
            }
            if (objRootBone) {
                objRootBone.traverse(bone => {
                    const matchingBone = g_characterBones.get(bone.name);
                    if (matchingBone) {
                        // bone.position.copy(matchingBone.position);
                        // bone.quaternion.copy(matchingBone.quaternion);
                        bone.position.copy(matchingBone.position)
                        bone.quaternion.copy(matchingBone.quaternion)
                        bone.scale.copy(matchingBone.scale)
                    }
                })
            }

        })
    }
    //在渲染循环中更新动画 
    animate() {
        var self = this
        this.animationID = requestAnimationFrame(() => {
            self.animate()
        });

        var deltaTime = clock.getDelta();
        if (this.actionMgr)
            this.actionMgr.updateMixerDelate(deltaTime)
        //绑定衣服与人物动作一致
        this.updateClothesBone2CharacterBone()
        if (this.audioPlayer) {
            this.audioPlayer.updateAudioDelta()
        }
        //眼睛动作
        this.eyeBlinkUpdate()

        //截图
        if (this.cutImgCallBack && this.cutState == 0 //需要截图，并且未在截图状态
            && this.morphControl && this.morphDict && this.morphControl[this.morphDict[EYE_BLINK_LEFT]] <= 0) {
            try {
                this.cutImag()
            }
            catch (e) {
                console.error(e)
            }
        }

        if (this.stats) {
            this.stats.update()
        }
        renderer.render(mainScene, mainCamera);
    }

    loadHdrModel(hdrModel) {
        return new Promise((resolve, reject) => {
            return resolve() //暂时不使用hdr环境光
            // 加载场景灯光
            let rgbeLoader = new EXRLoader();
            // myConsole('load hdr:', hdrModel)
            rgbeLoader.load(hdrModel, (texture) => {
                texture.mapping = THREE.EquirectangularReflectionMapping;
                mainScene.environment = texture;// 加了纹理，默认衣服显示有问题
                return resolve()
            }, (process) => {

            }, (err) => {
                console.error(err)
                reject()
            })
        })

    }

    loadMainGLTF(mainUrl, success, processCall, error) {
        // myConsole('加载模型:', this.mainModelMap)
        let urlMd5 = crypto.MD5(mainUrl).toString()
        if (this.mainModelMap.has(urlMd5)) {
            myConsole('模型已加载，直接返回 ', urlMd5)
            success && success(this.mainModelMap.get(urlMd5))
            return
        }
        if (this.mainLoader) {
            delete this.mainLoader
            this.mainLoader = null
        }
        this.mainLoader = new GLTFLoader();
        let self = this
        this.mainLoader.load(mainUrl,
            //loader.load('http://xcx.download.studio51.com/Female_V2.glb',
            function (gltf) {

                self.mainLoader = null
                // self.mainModelMap.set(urlMd5, gltf) //因为ios内存限制暂时去掉模型缓存
                success && success(gltf)
            },
            (process) => {
                processCall && processCall(process)
            },
            function (err) {
                error && error(err)
            }
        );
    }
    /**
     * 加载人物模型
     * mainUrl: 任务模型
     * defaultClothMeshName: 人物自带服装
     * hdrUrl 
     * changeCloth 默认更换服装
     */
    loadMainModel(mainUrl, defaultClothMeshName, hdrUrl, changeCloth, actions, defaultAction,config, processCallback, resultCallback) {

        myConsole('init main model---------',mainUrl)
        //保存默认服装名称
        g_defaultClothesNames.length = 0
        if (defaultClothMeshName && defaultClothMeshName.length > 0) {
            g_defaultClothesNames.push(...defaultClothMeshName)
        }

        //加载人物模型      
        if (this.g_model) {//删除旧模型
            mainScene.remove(this.g_model.scene)
            this.g_model.scene.traverse((child) => {
                if (child.material) {
                    child.material.dispose();
                   
                }
                if (child.geometry) {
                    child.geometry.dispose();
                    
                }
                child = null;
            });

            this.g_model = null
        }
       
        if(this.audioPlayer){
            this.audioPlayer.stopNowVoice()
        }
        const self = this
        // myConsole('mainScene', mainScene)
        this.loadMainGLTF(mainUrl,
            //loader.load('http://xcx.download.studio51.com/Female_V2.glb',
            async function (gltf) {
                self.reset()
                // myConsole("人物模型 ：", gltf.scene)
                // myConsole('默认服装 ', g_defaultClothesNames)
              
                 //删除服装
                m_defaultClothMesh && m_defaultClothMesh.length>0 && m_defaultClothMesh.forEach((child)=>{
                    child.material.dispose && child.material.dispose();
                })
                m_defaultClothMesh.length = 0
                
                self.clothSet && self.clothSet.size>0 && self.clothSet.forEach((child)=>{
                    // myConsole('---child',child)
                    child.scene && child.scene.material && child.scene.material.dispose && child.material.dispose();
                })
                g_clothesModels=[]
                g_characterBones.clear()
                m_defaultClothMesh=[]
                self.clothSet.clear()

                THREE.Cache.clear()
                if (self.actionMgr) {
                    self.actionMgr.release()
                    delete self.actionMgr
                    self.actionMgr = null

                }
                self.actionMgr = new ActionMgr(gltf.scene)

                g_removeDefaultFlag = false
                m_defaultClothMesh.length = 0
                m_defaultClothMesh.push(...self.getDefaultClotheObjs(gltf.scene, g_defaultClothesNames))
                self.g_model = gltf
                // myConsole("人物模型加载完成",mainScene);
                await self.loadHdrModel(hdrUrl)
                if (changeCloth && changeCloth.length > 0) {//有默认选择服饰，需要先把默认服饰替换
                    try {
                        await self.loadAndCloth(changeCloth, (process) => {
                            processCallback && processCallback({
                                finished: false,
                                percent: 80 + process.percent * 0.1
                            })
                        })
                    }
                    catch (e) {
                        console.error(e)
                        processCallback && processCallback({
                            finished: false,
                            percent: 90
                        })
                    }

                }
                if (!actions) {
                    actions = []
                }
                if (actions && actions.length > 0 && actions.indexOf(defaultAction) < 0) {//动作列表中没有空闲动作，手动添加
                    actions.push(defaultAction)
                }
                if (actions && actions.length > 0) {
                    try {
                        await self.actionMgr.loadFileToAction(actions, defaultAction, (process) => {
                            processCallback && processCallback({
                                finished: process.finished,
                                percent: 90 + process.percent * 0.1
                            })
                        })
                    }
                    catch (e) {
                        console.error(e)
                        processCallback && processCallback({
                            finished: true,
                            percent: 100
                        })
                    }

                }

                // gltf.scene.translateY(-0.03)
                mainScene.add(gltf.scene);
                // var helper = new THREE.SkeletonHelper( gltf.scene );
                // mainScene.add( helper );

                resultCallback && resultCallback(null, '人物加载成功')
                // if(config.gender ==2){ //女士因为眼睛向上看，暂时按照x轴旋转
                //     gltf.scene.rotation.x += 0.1;    
                    
                // }
                self.audioPlayer.initAudioDict(self.g_model)


                self.controls.saveState()
                //眨眼动作
                self.initEyeBlinkMorph()


                //设置动作
                // self.actionMgr.playAction('https://xcx.studio51.com/glb/M_ChaShou_V1.fbx')
                // self.actionMgr.loadFileToAction([
                //     'https://xcx.studio51.com/glb/M_ChaShou_V1.fbx',
                //     'https://xcx.studio51.com/glb/fbx/M_HuXi_V4.fbx' //https://xcx.studio51.com/glb/fbx/M_HuXi_V4.fbx
                // ],
                //     'https://xcx.studio51.com/glb/fbx/M_HuXi_V4.fbx').then(()=>{

                //         renderer.domElement.addEventListener(
                //             "click",
                //             event => {
                //                 myConsole('---------click')   
                //                 self.actionMgr.fadeToAction('https://xcx.studio51.com/glb/M_ChaShou_V1.fbx',0.5)
                //             }
                //         )
                //     })


            },
            (process) => {
                // myConsole("加载中", process);
                if (processCallback) {
                    if (changeCloth && changeCloth.length > 0) {//有默认要替换的衣服，需要将进度前90%作为模型加载进度 剩余10%作为衣服加载进度
                        if (process.total > 0) {
                            let loadPercent = process.loaded / process.total * 0.8
                            process.percent = loadPercent * 100
                        }
                        else {//未获取到大小
                            process.percent = 1
                        }

                    }
                    else if (actions && actions.length > 0) {
                        process.percent = (process.loaded / process.total) * 0.9
                    }
                    else {
                        process.percent = (process.loaded / process.total) * 100
                    }
                    processCallback(process)
                }
            },
            function (error) {
                console.error(error);
                if (resultCallback) {
                    resultCallback(error, '加载失败')
                }
            }
        );
    }
    /**
     * 重置虚拟人位置
     */
    resetHumanPosition() {
        this.controls.reset()
    }
    /**
    * 查询默认服装
    * @param {} bodyScene 
    */
    getDefaultClotheObjs(bodyScene, defaultMeshNames) {
        let defaultClothesObj = []
        if (!defaultMeshNames) {
            return defaultClothesObj
        }
        //去掉版本号进行比较
        let _defaultMeshNames = []
        for (let i = 0; i < defaultMeshNames.length; ++i) {
            _defaultMeshNames.push(utils.getModelNameRemoveVersion(defaultMeshNames[i]))
        }
        // myConsole(_defaultMeshNames)
        bodyScene.traverse(obj => {
            obj.isMesh && myConsole('===', utils.getModelNameRemoveVersion(obj.name))
            if (obj.isMesh
                && _defaultMeshNames
                && _defaultMeshNames.indexOf(utils.getModelNameRemoveVersion(obj.name)) >= 0) {

                defaultClothesObj.push(obj)
            }
        })
        // myConsole('------- 查询到默认服装', defaultClothesObj)
        return defaultClothesObj
    }


    //加载单个服装
    async loadClothScene(loader, url, index, clotheCount, processCallback) {
        return new Promise((resolve, reject) => {
            let clothUrlMd5 = crypto.MD5(url).toString();
            if (this.clothSet.get(clothUrlMd5)) {
                let percent
                if (index == clotheCount - 1) {
                    percent = 100;
                } else {
                    let itemProcess = 100 //将多个衣服的进度组成一个整体进度
                    let loadedProcess = ((1 / clotheCount * itemProcess + (index / clotheCount)) * 100).toFixed(2)
                    percent = loadedProcess;
                }
                if (processCallback) {
                    processCallback({
                        finished: percent == '100' ? true : false,
                        percent: percent
                    })
                }
                return resolve(this.clothSet.get(clothUrlMd5))
            }
            else {
                loader.load( //加载服装
                    url, //领带
                    (top) => {
                        //body.scene.add(top.scene)
                        this.clothSet.set(clothUrlMd5, top)
                        return resolve(top)
                    }, (process) => {

                        let percent
                        if (process.loaded >= process.total && index == clotheCount - 1) {
                            percent = 100;
                        } else {
                            let itemProcess = process.loaded / process.total //将多个衣服的进度组成一个整体进度
                            let loadedProcess = ((1 / clotheCount * itemProcess + (index / clotheCount)) * 100).toFixed(2)
                            percent = loadedProcess;
                        }
                        if (processCallback) {
                            processCallback({
                                finished: percent == '100' ? true : false,
                                percent: percent
                            })
                        }
                    },
                    (err => {
                        console.error('load error', err)
                        return reject()
                    })
                )
            }

        })
    }
    //加载多个服装
    async loadClothing(loader, urls, processCallback) {
        //改为一个个加载
        let clothesObjs = []
        for (let i = 0; i < urls.length; ++i) {
            try {
                clothesObjs.push(await this.loadClothScene(loader, urls[i], i, urls.length, processCallback))
            }
            catch (e) {
                console.error(e)
                throw ("服装加载失败")
            }

        }
        return clothesObjs
    }
    clothing(loader, bodyScene, clothesurl, processCallback) {
        //获取人物模型的骨骼
        const rootBone = bodyScene.getObjectByName("Armature").getObjectByName("RootNode").getObjectByName("Hips")
        g_characterBones.clear()
        rootBone.traverse(bone => {
            // myConsole('character bone', bone)
            g_characterBones.set(bone.name, bone)
        })
        // myConsole('character bones count', g_characterBones.size)
        //渲染服装
        return new Promise((resolve, reject) => {
            this.loadClothing(loader, clothesurl, processCallback).then(objs => {
                // myConsole('-----groups', objs)
                const modelArmature = bodyScene.getObjectByName("Armature")
                if (!modelArmature) {
                    return reject('渲染服装失败')
                }
                //添加衣服
                if (g_clothesModels.length) {
                    this.moveCloth(this.g_model.scene, g_clothesModels)
                }

                g_clothesModels.length = 0
                g_clothesModels.push(...objs);
                this.updateClothesBone2CharacterBone()
                objs.forEach(obj => {
                    modelArmature.add(obj.scene)
                })

                return resolve(objs)
            })
        })
    }

    moveCloth(bodyScene, clothGroup) {
        clothGroup.forEach(cloth => {
            cloth.scene.removeFromParent()
        })

    }
    /**
     * 移除默认服装
     * @param {} bodyScene 
     */
    removeDefaultClothe(defaultMeshObjs) {

        defaultMeshObjs.forEach(skin => {
            skin.traverse((child) => {
                if (child.material) {
                    child.material.dispose();
                }
                if (child.geometry) {
                    child.geometry.dispose();
                }
                child.clear()
                child = null;
            });
            skin.clear()
            skin.removeFromParent()
            skin = null
        })
    }

    /**
     * 加载并穿上服装
     * @param {*} clothes 
     */
    loadAndCloth(clothes, processCallback, resultCallback) {
        return new Promise((resolve, reject) => {
            if (!this.g_model) {
                resolve()
                if (resultCallback) resultCallback('人物模型还未加载')

                return
            }
            if (!clothes || clothes.length == 0) {
                resolve()
                processCallback && processCallback({ finished: true, percent: 100 })
                resultCallback && resultCallback(null, '未指定服装')

                return
            }
            // 加载衣服之前先保存之前的衣服
            // let _curClothGroup = this.curClothGroup
            let loader = new GLTFLoader()
            this.clothing(loader, this.g_model.scene, clothes, processCallback).then(res => {
                // this.curClothGroup = res
                loader = null
                myConsole('cloth load success');
                //第一次加载去除旧衣服
                if (!g_removeDefaultFlag) {
                    //第一次加载，去掉默认服饰
                    // myConsole('----remove default clothe', m_defaultClothMesh)
                    this.removeDefaultClothe(m_defaultClothMesh)
                    m_defaultClothMesh.forEach((child)=>{
                        child.material.dispose && child.material.dispose();
                    })
                    g_removeDefaultFlag = true

                }
                // //衣服加载之后，删除旧衣服
                // if (_curClothGroup) {
                //     this.moveCloth(this.g_model.scene, _curClothGroup)
                // }
                resolve()
                if (resultCallback) resultCallback(null, '换装成功')

            }, e => {
                loader = null
                console.error(e)
                resolve()
                if (resultCallback) resultCallback('服装加载失败', e)
            })
        })

    }

    /**
     * 向虚拟人发送聊天消息
     * @param {*} message 
     * @param {*} resultCallback 
     */
    // @deprecated //方法已经启用，请在sdk外部调用聊天接口 
    chat2MetaHuman(message, messageType, resultCallback, eventHandler) {
        myConsole('blob message', message)
        if (!message || message.length == 0) {
            return;
        }
        let url = `${this.config.HUMAN_URL}`
        let body = {
            app_id: this.appID,
            sign: this.config.HUMAN_SIGN,
            access_token: this.token
        }

        if (messageType == CHAT_MSG_TYPE.VOICE_STREAM) {
            body['voice'] = message
        }
        else {
            body['word'] = `${message}`
        }
        myConsole('请求聊天:', url, body)
        utils.postData(url, 'applet/webview/dialog', body).then((res) => {
            myConsole('聊天回答:', res)
            if (res.code != 200) {
                if (resultCallback) resultCallback(res.msg, '发送聊天消息失败')
                return
            }
            this.say(res.data.resp, res.data.url, res.data.viseme, resultCallback, eventHandler)

        }, err => {
            resultCallback('聊天接口调用失败:' + err, '聊天接口调用失败')
        })
    }

    stopNowVoice() {
        if (this.audioPlayer) {
            this.audioPlayer.stopNowVoice()
        }
    }

    initEyeBlinkMorph() {
        if (!this.g_model) {
            return
        }
        this.g_model.scene.getObjectByName("Armature") && this.g_model.scene.getObjectByName("Armature").traverse(o => {
            if (o.morphTargetInfluences) {
                this.morphControl = o.morphTargetInfluences
                this.morphDict = o.morphTargetDictionary
                // myConsole('找到形态键：', o.name, o.morphTargetDictionary)
            }
        })
    }
    /**
     * 自动眨眼
     */

    eyeBlinkUpdate() {

        if (!this.morphControl || !this.morphDict || this.cutState) {
            return
        }
        if (this.morphDict[EYE_BLINK_LEFT] == undefined || this.morphControl[this.morphDict[EYE_BLINK_RIGHT]] == undefined) {
            return
        }
        if (this.morphControl[this.morphDict[EYE_BLINK_LEFT]] <= 0) {
            if (this.lidWait > eyeBlindWaitCount) {
                this.lidMove = this.lidSpeed;
                this.lidWait = 0;
            } else {
                this.lidMove = 0;
            }
            this.lidWait += 1;
        } else if (this.morphControl[this.morphDict[EYE_BLINK_LEFT]] > 1) {
            this.lidMove = -this.lidMove;
        }

        this.morphControl[this.morphDict[EYE_BLINK_LEFT]] += this.lidMove;
        this.morphControl[this.morphDict[EYE_BLINK_RIGHT]] += this.lidMove;


    }

    /**
     * 清除缓存
     */
    clearThreeCatch() {
        if (this.animationID) {
            cancelAnimationFrame(this.animationID)
        }
        if (this.g_model) {//删除模型
            this.g_model.scene.traverse((child) => {
                if (child.material) {
                    child.material.dispose();
                }
                if (child.geometry) {
                    child.geometry.dispose();
                }
                child = null;
            });

            this.g_model && this.g_model.scene.removeFromParent()
            this.g_model = null
        }
        renderer.dispose()
        renderer.forceContextLoss()
        renderer.content = null
        let gl = renderer.domElement.getContext("webgl")
        gl && gl.getExtension("WEBGL_lose_context") && gl.getExtension("WEBGL_lose_context").loseContext()
        renderer = null
        mainCamera = null
        mainScene = null
        // THREE.Cache.clear()
        myConsole('清除 缓存')
    }
    showStats(show) {
        myConsole('show stats', show, this.stats.dom.style)

        if (show) {
            this.stats && (this.stats.dom.style.display = 'block')
        }
        else {
            this.stats && (this.stats.dom.style.display = 'none')
        }
    }
    /**
     * 播报并播放动作
     * @param {*} audio 
     * @param {*} audioVisem 
     * @param {*} action  动作文件，可以为空，代表没有动作
     * @param {*} resultCallback(err,res)
     * @param {*} eventHandler
     */
    say(audio, audioVisem, duration,conf,resultCallback, eventHandler) {
        if (!this.g_model) {
            return resultCallback && resultCallback('模型还未加载')
        }
        let lastTime = 0
        if (audioVisem && audioVisem.length > 0) {//最后一个音素的时间代表音频文件的总时长
            lastTime = audioVisem[audioVisem.length - 1].time
        }
        if (this.audioPlayer) {
            if (eventHandler) this.audioPlayer.setEventListener(eventHandler)
            this.audioPlayer.playAudio(
                this.g_model,
                audio,
                audioVisem,
                '', //播放文字，暂时保留
                duration,
                conf
            )
        }

        if (resultCallback) {
            resultCallback(null,
                {
                    voiceDuration: lastTime,
                }
            )
        }

    }

    playAction(action, fadeDuration) {
        this.actionMgr.fadeToAction(action, fadeDuration || 1)
    }
    playIdleAction() {
        myConsole('播放空闲动作')
        this.actionMgr.actionFinished()
    }

    cutImag() {
        this.cutState = 1

        let divID = 'webgl_tmp_img'
        try {
            //使用当前的渲染数据生成一张图片并盖住模型
            // 创建一个div元素，并将其添加到DOM中
            const canvas = renderer.domElement
            const rect = canvas.getBoundingClientRect();
            // myConsole('cavas rect', rect)
            const div = document.createElement('div');
            div.id = divID
            div.style.position = 'absolute';
            div.style.top = `${rect.top}px`;
            div.style.left = `${rect.left}px`;
            div.style.width = `${rect.width}px`;
            div.style.height = `${rect.height}px`;
            div.style.margin = 'auto';
            div.style.zIndex = '0'
            this.container.appendChild(div);
            // myConsole('cavas div', div.style)
            // 创建一个Image对象，并加载图片
            mainScene.background = new THREE.Color(0x616e75);
            renderer.render(mainScene, mainCamera)
            let srcPre = renderer.domElement.toDataURL("image/jpeg");
            let img = new Image();
            img.src = srcPre;
            let self = this
            // 在图片加载完成后，将其添加到div中
            function reset(){
                setTimeout(() => {
                    mainCamera.position.z=cameraPosition[2];
                    document.getElementById(divID) && document.getElementById(divID).remove();

                }, 1000)
                self.cutState = 0
                self.cutImgCallBack = null
            }
            img.onerror=()=>{
                reset()
            }
            img.onload = function () {
                // 创建一个img元素，并将其添加到div中
                const imgElement = document.createElement('img');
                imgElement.src = srcPre;
                imgElement.style.width = '100%';
                imgElement.style.height = '100%';
                div.appendChild(imgElement);

                setTimeout(() => {//延时1秒，避免div还未刷新导致屏幕闪动
                    //开始截取真正的屏幕    
                    self.resetHumanPosition()
                    mainCamera.position.z=cameraCutImgPosition[2]
                    mainScene.background = null
                    renderer.render(mainScene, mainCamera)
                    let src = renderer.domElement.toDataURL();//将选中的canvas转换为base64编码
                    // let a = document.createElement("a"); // 生成一个a元素
                    // let event = new MouseEvent("click"); // 创建一个单击事件
                    // a.download = "photo"; // 设置图片名称
                    // a.href = src; // 将生成的URL设置为a.href属性
                    // a.dispatchEvent(event); // 触发a的单击事件 将图片下载下来
                    //将数据转为form data 用于上传
                    //去除 data URL 中的头部说明

                    self.cutImgCallBack && self.cutImgCallBack(null, utils.dataURLToBlob(src))

                    reset()
                }, 1000)

            }
        }
        catch (e) {
            console.error(e)
            document.getElementById(divID) && document.getElementById(divID).remove();
            this.cutState = 0
            this.cutImgCallBack = null
        }


    }
    downloadCanvasImg(callback) {
        //截屏的时候，需要等眼睛全部睁开
        if (this.cutState) {
            return callback('正在处理，稍后再试')
        }
        this.cutImgCallBack = callback

    }
    setAudioMuted(muted){
        this.audioPlayer.setAudioMuted(muted)
    }
    setJWAOpenValue(value){
        this.audioPlayer.setJWAOpenValue(value)
    }

}
export default WebGlLoader; 


// WEBPACK FOOTER //
// ./src/S51WebGLSDK/WebGlLoader.js